import {showPopUp} from "components/PopUp";
import {useEffect} from "react";
import {useSelector} from "react-redux";
import OneButtonPopup from "./OneButtonPopup";
import TwoButtonPopup from "./TwoButtonPopup";
import BumperAd from "../Canvas/Ad/BumperAd";

import View from "./View";
import {isMobile} from "react-device-detect";

export default function Container({redbrickEventProjectKey}) {
  const {gameState, messageFromGame} = useSelector(state => state.game);

  useEffect(() => {
    if (messageFromGame && messageFromGame.popupType) {
      switch (messageFromGame.popupType) {
        case "oneButtonPopup":
          showPopUp(
            <OneButtonPopup textSet={messageFromGame.textSet} buttonText={messageFromGame.buttonText} handler={messageFromGame.handler} />,
            {
              defaultPadding: false,
              transparentBackground: true,
              clearOverHidden: true,
            },
          );
          break;
        case "twoButtonPopup":
          showPopUp(
            <TwoButtonPopup
              textSet={messageFromGame.textSet}
              leftButtonText={messageFromGame.leftButtonText}
              rightButtonText={messageFromGame.rightButtonText}
              leftHandler={messageFromGame.leftHandler}
              rightHandler={messageFromGame.rightHandler}
            />,
            {
              defaultPadding: false,
              transparentBackground: true,
              clearOverHidden: true,
            },
          );
          break;
        default:
          break;
      }
    }
  }, [messageFromGame]);
  return (
    <>
      <View redbrickEventProjectKey={redbrickEventProjectKey} />
      {!isMobile && <BumperAd />}
    </>
  );
}
